import styled from "@emotion/styled";

export const Container = styled.div<{ disabled?: boolean }>`
  display: flex;
  padding: 20px;
  flex-direction: column;
  justify-content: space-between;
  /* align-items: center; */
  flex: 1 0 0;
  align-self: stretch;
  min-height: 140px;

  box-sizing: border-box;

  border-radius: 12px;
  border: 1px solid var(--alias-color-line-normal);
  background: ${(props) =>
    props.disabled
      ? "var(--alias-color-background-normal-alternative)"
      : "var(--alias-color-background-normal-normal)"};
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;
